import React, { Fragment, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import withRouter from "components/Common/withRouter";
import { useDispatch, useSelector } from "react-redux";
import Multiselect from 'multiselect-react-dropdown';
import { Link } from 'react-router-dom';
import './azureresources.scss'
import ResourceTableRow from '../../components/Resources/ResourceTableRow';
import ResourceActions from '../../components/Resources/ResourceActions';
import DefaultAlertsModal from '../../components/Resources/Modal/DefaultAlertsModal';
import MapOpsGenieModal from '../../components/Resources/Modal/MapOpsGenieModal';
import MapPagerDutyModal from '../../components/Resources/Modal/MapPagerDutyModal';
import MapResourceServiceModal from '../../components/Resources/Modal/MapResourceServiceModal';
import Loader from "../../components/Loader/Loader";
import connectTeamLottie from '../../assets/images/connect_team_lottie.json';
import delpoyAlertsLottie from '../../assets/images/deploy_alerts_lottie.json';
import refreshResourcesLottie from '../../assets/images/refresh_resources_lottie.json';
import {
    Card,
    Col, DropdownItem,
    Row,
} from "reactstrap";
import {
    getAzureRefresh as onGetAzureRefresh,
    getAzureAllResourceAlertsPage as onGetAzureAllResourceAlertsPage,
    getAzureCloudResources as onGetAzureCloudResources,
    getAzureNotificationChannels as onGetAzureNotificationChannels,
    getOpsGenieTeams as onGetOpsGenieTeams,
    postAzureCreateResourceAlerts as onPostAzureCreateResourceAlerts,
    getPagerdutyServices as onGetPagerdutyServices,
    postAzureResourcePagerdutyServiceMapping as onPostAzureResourcePagerdutyServiceMapping,
    postAzureResourceOpsGenieTeamMapping as onPostAzureResourceOpsgenieTeamMapping,
    postAzureResourceServiceMapping as onPostAzureResourceServiceMapping,
    getAzureAllResourceAlertsPageCount as onGetAzureAllResourceAlertsPageCount,
    getAllOrgAzureResourceTypes,
    getAzureRefreshScanStatus
} from '../../store/actions'

const AzureResourceTab = props => {

    const { azure_cloudResources } = useSelector(state => ({
        azure_cloudResources: state.AzureResource.azure_cloudResources || [],
    }));

    const { azure_all_resource_alerts } = useSelector(state => ({
        azure_all_resource_alerts: state.AzureResource.azure_all_resource_alerts || {},
    }));

    const { azure_all_resource_count } = useSelector(state => ({
        azure_all_resource_count: state.AzureResource.azure_all_resource_count || {},
    }));

    const { orgAzureResourceTypes } = useSelector(state => ({
        orgAzureResourceTypes: state.AzureResource.orgAzureResourceTypes || {}
    }))

    let { current_notification_channels } = useSelector(state => ({
        current_notification_channels: state.AzureResource.notification_channels || [],
    }))

    const { opsgenie_teams } = useSelector(state => ({
        opsgenie_teams: state.OpsGenieTeams.opsgenie_teams,
    }));

    const { pagerduty_services } = useSelector(state => ({
        pagerduty_services: state.PagerdutyServices.pagerduty_services,
    }));

    const {azure_rescan_status} = useSelector(state => ({
        azure_rescan_status: state.AzureResource.azure_rescan_status,
    }))

    const [search, setSearch] = useState("");
    const [region, setRegion] = useState("")
    const [searchResource, setSearchResource] = useState([]);
    const [searchService, setSearchService] = useState([]);
    const [searchEnvironment, setSearchEnvironment] = useState([]);
    const [searchHealth, setSearchHealth] = useState([]);
    const [azureDeployModal, setAzureDeployModal] = useState(false);
    const [mapOpsGenieTeamModal, setMapOpsGenieTeamModal] = useState(false);
    const [mapServiceModal, setMapServiceModal] = useState(false);
    const [changeEnvModal, setChangeEnvModal] = useState(false);
    const [mapResourcePagerdutyServiceModal, setMapResourcePagerdutyServiceModal] = useState(false);
    const dispatch = useDispatch();
    const itemsPerPage = 50;
    const total_resources = azure_all_resource_count?.resource_count || 0;
    const [filteredResources, setFilteredResources] = useState(azure_all_resource_alerts || {});
    const [resourceFilter, setResourceFilter] = useState([]);
    const [selectedPage, setSelectedPage] = useState(1);
    const [environmentName, setEnvironmentName] = useState('PRODUCTION');
    const [serviceName, setServiceName] = useState({});
    const [opsgenieTeamName, setOpsgenieTeamName] = useState({});
    const [pagerdutyServiceName, setPagerdutyServiceName] = useState({});
    const [allServices, setAllServices] = useState({});
    const [allOpsGenieTeams, setAllOpsGenieTeams] = useState({});
    const [allPagerdutyServices, setAllPagerdutyServices] = useState({});
    const [checkBox, setCheckBox] = useState({});
    const [deployButton, setDeployButton] = useState(false);
    const [mapButton, setMapButton] = useState(false);
    const [allCheckBox, setAllCheckBox] = useState(false);
    const [isLoading1, setIsLoading1] = useState(false);
    const [isLoading2, setIsLoading2] = useState(false);
    const [azureRefreshModal, setAzureRefreshModal] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [initiateRescan, setInitiateRescan] = useState(false);
    const [initialResourceFilter, setInitialResourceFilter] = useState([]);
    const [initialEnvironmentFilter, setInitialEnvironmentFilter] = useState([]);
    const [initialHealthFilter, setInitialHealthFilter] = useState([]);
    const [initialServiceFilter, setInitialServiceFilter] = useState([]);
    const serviceRef = useRef();

    function formatDate(dates) {
        const date = new Date(dates);
        const utcDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
        return utcDate.toUTCString();
    }
    let environments = [
        { value: 'PRODUCTION', label: 'PRODUCTION' },
        { value: 'UAT', label: 'UAT' },
        { value: 'STAGING', label: 'STAGING' },
        { value: 'PREPROD', label: 'PREPROD' },
        { value: 'DEV', label: 'DEV' },
        { value: 'OTHER', label: 'OTHER' },]

    let environmentsFilter = [
        { id: 'PRODUCTION', name: 'PRODUCTION' },
        { id: 'UAT', name: 'UAT' },
        { id: 'STAGING', name: 'STAGING' },
        { id: 'PREPROD', name: 'PREPROD' },
        { id: 'DEV', name: 'DEV' },
        { id: 'OTHER', name: 'OTHER' },]

    let healthFilter = [
        { id: 'red', name: 'RED' },
        { id: 'amber', name: 'AMBER' },
        { id: 'green', name: 'GREEN' },]

    let serviceOptions = [];
    let serviceValue = {}

    let opsGenieTeamOptions = [];
    let opsGenieTeamValue = {}

    let pagerdutyServiceOptions = [];
    let pagerdutyServiceValue = {}

    useEffect(() => {
        dispatch(getAllOrgAzureResourceTypes());
    }, [getAllOrgAzureResourceTypes]);

    useEffect(() => {
        dispatch(onGetAzureNotificationChannels());
    }, [onGetAzureNotificationChannels]);

    useEffect(() => {
        setFilteredResources(azure_all_resource_alerts);
        setIsLoading(false);
    }, [azure_all_resource_alerts]);


    useEffect(() => {
        let resourceFilterTemp = []
        orgAzureResourceTypes.forEach(key => {
            resourceFilterTemp.push({
                name: key.name.replace('Azure/', ''),
                id: key.id,
            });
        });
        setResourceFilter(resourceFilterTemp);
    }, [orgAzureResourceTypes]);

    useEffect(() => {
        dispatch(onGetOpsGenieTeams())
    }, [onGetOpsGenieTeams])


    useEffect(() => {
        dispatch(onGetPagerdutyServices());
    }, [onGetPagerdutyServices]);

    const startLoading1 = () => {
        setIsLoading1(true);
        setTimeout(() => {
            setIsLoading1(false);
        }, 4000);
    };

    const startLoading2 = () => {
        setIsLoading2(true);
        setTimeout(() => {
            setIsLoading2(false);
        }, 4000);
    };

    const startLoading_refresh = () => {
        setAzureRefreshModal(true);
        setTimeout(() => {
            setAzureRefreshModal(false);
        }, 5000);
    };

    const cancelDeployModal = () => {
        setAzureDeployModal(false);
    }

    const cancelMapOpsGenieTeamModal = () => {
        setMapOpsGenieTeamModal(false);
    }

    const cancelMapResourcePagerdutyServiceModal = () => {
        setMapResourcePagerdutyServiceModal(false);
    }

    const cancelMapServiceModal = () => {
        setMapServiceModal(false);
    }

    let handleOGFormChange = (event) => {
        if (event !== null) {
            if (event['__isNew__'] === true) {
                setOpsgenieTeamName({
                    'name': 'opsgenie_team_name',
                    'value': event.value
                });
            } else {
                setOpsgenieTeamName({
                    'name': 'opsgenie_team_id',
                    'value': event.value
                });
            }
        }
    }

    let handlePDFormChange = (event) => {
        if (event !== null) {
            if (event['__isNew__'] === true) {
                setPagerdutyServiceName({
                    'name': 'pagerduty_service_name',
                    'value': event.value
                });
            } else {
                setPagerdutyServiceName({
                    'name': 'pagerduty_service_id',
                    'value': event.value
                });
            }
        }
    }

    let handleServiceFormChange = (event) => {
        if (event !== null) {
            if (event['__isNew__'] === true) {
                setServiceName({
                    'name': 'application_service_name',
                    'value': event.value
                });
            } else {
                setServiceName({
                    'name': 'application_service_id',
                    'value': event.value
                });
            }
        }
    }

    let handleEnvironmentChange = (event) => {
        if (event !== null) {
            if (event['__isNew__'] === true) {
                setEnvironmentName({
                    'name': 'environment',
                    'value': event.value
                });
            } else {
                setEnvironmentName({
                    'name': 'environment',
                    'value': event.value
                });
            }
        }
    }

    const handleOpsGenieTeamMapping = () => {
        let resourceIds = [];
        Object.keys(checkBox).map((key, index) => {
            if (checkBox[key] === true) {
                resourceIds.push(filteredResources[key].id);
            }
        })
        let payload = {};
        if (opsgenieTeamName.name === 'opsgenie_team_name') {
            payload = {
                'azure_monitored_resource_ids': resourceIds,
                'opsgenie_team_name': opsgenieTeamName.value
            };
        } else {
            payload = {
                'azure_monitored_resource_ids': resourceIds,
                'opsgenie_team_id': opsgenieTeamName.value
            };
        }
        payload['environment'] = environmentName.value;
        dispatch(onPostAzureResourceOpsgenieTeamMapping(payload));
        setMapOpsGenieTeamModal(false);
    }

    const handlePagerdutyServiceMapping = () => {
        let resourceIds = [];
        Object.keys(checkBox).map((key, index) => {
            if (checkBox[key] === true) {
                resourceIds.push(filteredResources[key].id);
            }
        })
        let payload = {};
        if (pagerdutyServiceName.name === 'pagerduty_service_name') {
            payload = {
                'azure_monitored_resource_ids': resourceIds,
                'pagerduty_service_name': pagerdutyServiceName.value
            };
        } else {
            payload = {
                'azure_monitored_resource_ids': resourceIds,
                'pagerduty_service_id': pagerdutyServiceName.value
            };
        }
        payload['environment'] = environmentName.value;
        dispatch(onPostAzureResourcePagerdutyServiceMapping(payload));
        setMapResourcePagerdutyServiceModal(false);
    }

    const handleServiceMapping = () => {
        let resourceIds = [];
        Object.keys(checkBox).map((key, index) => {
            if (checkBox[key] === true) {
                resourceIds.push(filteredResources[key].id);
            }
        })
        let payload = {};
        if (serviceName.name === 'service_name') {
            payload = {
                'azure_monitored_resource_ids': resourceIds,
                'application_service_name': serviceName.value
            };
        } else {
            payload = {
                'azure_monitored_resource_ids': resourceIds,
                'application_service_id': serviceName.value
            };
        }

        payload['environment'] = environmentName.value;
        dispatch(onPostAzureResourceServiceMapping(payload));
        let checkBoxObj = {};
        Object.assign(checkBoxObj, checkBox);
        setCheckBox({});
        setMapServiceModal(false);
    }

    props.services.map((service) => {
        allServices[service.id] = service.name;
        serviceOptions.push({ value: service.id, label: service.name });
        serviceValue[service.id] = { value: service.id, label: service.name }
    });

    opsgenie_teams.map((opsgenie_team) => {
        allOpsGenieTeams[opsgenie_team.id] = opsgenie_team.name;
        opsGenieTeamOptions.push({ value: opsgenie_team.id, label: opsgenie_team.name });
        opsGenieTeamValue[opsgenie_team.id] = { value: opsgenie_team.id, label: opsgenie_team.name }
    });

    pagerduty_services.map((pagerduty_service) => {
        allPagerdutyServices[pagerduty_service.id] = pagerduty_service.name;
        pagerdutyServiceOptions.push({ value: pagerduty_service.id, label: pagerduty_service.name });
        pagerdutyServiceValue[pagerduty_service.id] = { value: pagerduty_service.id, label: pagerduty_service.name }
    });
    const handleDeploy = () => {
        const selectedResources = Object.keys(checkBox)
            .filter((key) => checkBox[key] === true &&
                (filteredResources[key].application_service_email_id !== null ||
                    filteredResources[key].opsgenie_team_id !== null ||
                    filteredResources[key].pagerduty_service_id !== null))
            .map((key) => filteredResources[key].id);

        if (selectedResources.length > 0) {
            let payload = {
                'azure_monitored_resource_ids': selectedResources,
            };
            dispatch(onPostAzureCreateResourceAlerts(payload), props.router.navigate);
        }

        setAzureDeployModal(false);
    }

    const handleIndividualDeploy = (resourceId) => {
        let payload = {
            'azure_monitored_resource_ids': [resourceId],
        }
        dispatch(onPostAzureCreateResourceAlerts(payload), props.router.navigate);
    }

    const handlePageClick = (pageNumber) => {
        setIsLoading(true);

        if (pageNumber < 1) {
            setIsLoading(false);
            return;
        }

        if (selectedPage < pageNumber && Object.keys(filteredResources).length < itemsPerPage) {
            setIsLoading(false);
            return;
        }

        setCheckBox({});
        setAllCheckBox(false);
        setSelectedPage(pageNumber);

        let pageFilters = {}
        let queryParams = {};
        let resourceTypes = searchResource.map((resource) => resource.id);
        if (resourceTypes.length > 0) {
            pageFilters['resource_types'] = resourceTypes;
            queryParams['rt'] = ConvertResourceIdsToNames(resourceTypes);
        }

        let application_service_ids = []
        let opsgenie_team_ids = []
        let pagerduty_service_ids = []

        current_notification_channels.forEach((notification_channel) => {
            if (notification_channel.is_primary === true) {
              if (notification_channel.name === "Email") {
                searchService.forEach((service) => {
                  application_service_ids.push(service.value);
                });
                pageFilters['application_service_ids'] = application_service_ids;
                if (application_service_ids.length > 0) {
                  queryParams['as'] = convertServiceIdsToNames(application_service_ids,notification_channel.name);
                }
              } else if (notification_channel.name === "PagerDuty") {
                searchService.forEach((service) => {
                  pagerduty_service_ids.push(service.value);
                });
                pageFilters['pagerduty_service_ids'] = pagerduty_service_ids;
                if (pagerduty_service_ids.length > 0) {
                  queryParams['pd'] = convertServiceIdsToNames(pagerduty_service_ids,notification_channel.name);
                }
              } else if (notification_channel.name === "OpsGenie") {
                searchService.forEach((service) => {
                  opsgenie_team_ids.push(service.value);
                });
                pageFilters['opsgenie_team_ids'] = opsgenie_team_ids;
                if (opsgenie_team_ids.length > 0) {
                  queryParams['og'] = convertServiceIdsToNames(opsgenie_team_ids,notification_channel.name);
                }
              }
            }
          });

          const selectedEnvironments = searchEnvironment.map((env) => env.name);
          if (selectedEnvironments.length > 0) {
          pageFilters['environments'] = selectedEnvironments;
          queryParams['environments'] = selectedEnvironments.join(',');
          }

          const selectedHealths = searchHealth.map((health) => health.id);
          if (selectedHealths.length > 0) {
          pageFilters['health_filter'] = selectedHealths;
          queryParams['health_filter'] = selectedHealths.join(',');
          }

          const formattedStartDate = startDate ? formatDate(startDate) : null;
          const formattedEndDate = endDate ? formatDate(endDate) : null;
          if (formattedStartDate) {
          pageFilters['start_date'] = formattedStartDate;
          queryParams['start_date'] = formattedStartDate;
          }
          if (formattedEndDate) {
          pageFilters['end_date'] = formattedEndDate;
          queryParams['end_date'] = formattedEndDate;
          }

          if (region) {
          pageFilters['region'] = region;
          }
          if (region && typeof region === 'string') {
          queryParams['region'] = region;
          }

        pageFilters['page'] = pageNumber;
        pageFilters['limit'] = itemsPerPage;
        pageFilters['search_item'] = search;
        queryParams['page'] = pageNumber;
        if(search && typeof search === 'string' && search!=='[Object object]'){
        queryParams['search_item'] = search;
        }
        queryParams['limit'] = itemsPerPage;

        const filteredParams = new URLSearchParams(queryParams).toString();
        window.history.pushState(null, '', `?${filteredParams}`);
        dispatch(onGetAzureAllResourceAlertsPage(pageFilters));
        dispatch(onGetAzureAllResourceAlertsPageCount(pageFilters));
        setSelectedPage(pageNumber);
        setIsLoading(false);
    };

    const convertServiceIdsToNames = (serviceIds,notification_channel_name) => {
        let names = [];
        if (notification_channel_name === "Email") {
            serviceIds.forEach((id) => {
            const matchedService = serviceOptions.find((service) => service.value === id);
            if (matchedService) {
                names.push(matchedService.label);
            }
            });
        }
        else if (notification_channel_name === "PagerDuty") {
            serviceIds.forEach((id) => {
                const matchedService = pagerdutyServiceOptions.find((service) => service.value === id);
                if (matchedService) {
                names.push(matchedService.label);
                }
            });
        }
        else if (notification_channel_name === "OpsGenie") {
            serviceIds.forEach((id) => {
                const matchedService = opsGenieTeamOptions.find((service) => service.value === id);
                if (matchedService) {
                names.push(matchedService.label);
                }
            });
        }
        return names;
        };

    const convertServiceNamesToIds = (names, notification_channel_name) => {
    let ids = [];

    if (notification_channel_name === "Email") {
        names?.forEach((name) => {
        const matchedService = serviceOptions.find((service) => service.label === name);
        if (matchedService) {
            ids.push(matchedService.value);
        }
        });
    } else if (notification_channel_name === "PagerDuty") {
        names?.forEach((name) => {
        const matchedService = pagerdutyServiceOptions.find((service) => service.label === name);
        if (matchedService) {
            ids.push(matchedService.value);
        }
        });
    } else if (notification_channel_name === "OpsGenie") {
        names?.forEach((name) => {
        const matchedService = opsGenieTeamOptions.find((service) => service.label === name);
        if (matchedService) {
            ids.push(matchedService.value);
        }
        });
    }

    return ids;
    }

    const ConvertResourceIdsToNames = (resourceIds) => {
    let names = [];
    resourceIds.forEach((id) => {
        const matchedResource = orgAzureResourceTypes.find((resource) => resource.id === id);
        if (matchedResource) {
        names.push(matchedResource.name);
        }
    });
    return names;
    }
    const ConvertResourceNamesToIds = (names) => {
    let ids = [];
    names?.forEach((name) => {
        const matchedResource = orgAzureResourceTypes.find((resource) => resource.name === name);
        if (matchedResource) {
        ids.push(matchedResource.id);
        }
    });
    return ids;
    }

    const handleStartDateChange = (event) => {
        const dateValue = event.target.value;
        setStartDate(dateValue ? new Date(dateValue) : null);
    };

    const handleEndDateChange = (event) => {
        const dateValue = event.target.value;
        const newEndDate = dateValue ? new Date(dateValue) : null;
        if (startDate && newEndDate && newEndDate < startDate) {
            showNotification("error", "End date cannot be before the start date")
            return;
        }
        setEndDate(newEndDate);
    };

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        let pageFilters = {};
        const initialPage = queryParams.get('page') || 1;
        const resourceTypes = ConvertResourceNamesToIds(queryParams.get('rt')?.split(','));

        if (resourceTypes?.length > 0 && orgAzureResourceTypes?.length > 0) {
          pageFilters['resource_types'] = resourceTypes;
          const resourceTypeObjects = orgAzureResourceTypes
            .filter(resource => resourceTypes.includes(resource.id))
            .map(resource => ({ id: resource.id, name: resource.name }));

          setSearchResource(resourceTypeObjects);
          setInitialResourceFilter(resourceTypeObjects);
        }
        const serviceTypes = {
          'as': { options: serviceOptions, channelName: 'Email', filterKey: 'application_service_ids' },
          'og': { options: opsGenieTeamOptions, channelName: 'OpsGenie', filterKey: 'opsgenie_team_ids' },
          'pd': { options: pagerdutyServiceOptions, channelName: 'PagerDuty', filterKey: 'pagerduty_service_ids' }
        };

        let allServiceObjects = [];
        Object.entries(serviceTypes).forEach(([paramKey, { options, channelName, filterKey }]) => {
          const serviceNames = queryParams.get(paramKey)?.split(',') || [];
          if (serviceNames.length > 0) {
            const serviceIds = convertServiceNamesToIds(serviceNames, channelName);
            const serviceObjects = options
              .filter(service => serviceIds.includes(service.value))
              .map(service => ({ value: service.value, label: service.label }));

            if (serviceIds.length > 0) {
              pageFilters[filterKey] = serviceIds;
            }

            allServiceObjects = [...allServiceObjects, ...serviceObjects];
          }
        });

        if (allServiceObjects.length > 0) {
          setSearchService(allServiceObjects);
          setInitialServiceFilter(allServiceObjects);
        }
        const environments = queryParams.get('environments')?.split(',');
        if (environments?.length > 0) {
          const environmentsFilterObjects = environments.map(id => {
            const filter = environmentsFilter.find(item => item.id === id);
            return filter ? { id: filter.id, name: filter.name } : null;
          }).filter(Boolean);
          pageFilters['environments'] = environments;
          setSearchEnvironment(environmentsFilterObjects);
          setInitialEnvironmentFilter(environmentsFilterObjects);
        }

        const healthFilterIds = queryParams.get('health_filter')?.split(',');
        if (healthFilterIds?.length > 0) {
          const healthFilterObjects = healthFilterIds.map(id => {
            const filter = healthFilter.find(item => item.id === id);
            return filter ? { id: filter.id, name: filter.name } : null;
          }).filter(Boolean);

        setSearchHealth(healthFilterObjects);
        setInitialHealthFilter(healthFilterObjects);
        pageFilters['health_filter'] = healthFilterIds;
        }

        const startDate = queryParams.get('start_date');
        if (startDate) {
          pageFilters['start_date'] = startDate;
          setStartDate(new Date(startDate));
        }

        const endDate = queryParams.get('end_date');
        if (endDate) {
          pageFilters['end_date'] = endDate;
          setEndDate(new Date(endDate));
        }

        const searchItem = queryParams.get('search_item');
        if (searchItem && typeof searchItem === 'string') {
          setSearch(searchItem)
          pageFilters['search_item'] = searchItem;
        }

        const region = queryParams.get('region');
        if (region && typeof region === 'string') {
          pageFilters['region'] = region;
          setRegion(region);
        }

        pageFilters['page'] = Number(initialPage);
        pageFilters['limit'] = itemsPerPage;
        if(orgAzureResourceTypes.length>0){
            dispatch(onGetAzureAllResourceAlertsPage(pageFilters));
            dispatch(onGetAzureAllResourceAlertsPageCount(pageFilters));
        }
      }, [dispatch, itemsPerPage,orgAzureResourceTypes.length,serviceOptions.length,opsGenieTeamOptions.length,pagerdutyServiceOptions.length]);

    const handlePredefinedDateChange = (days) => {
        const today = new Date();
        const startDate = new Date(today);
        startDate.setDate(today.getDate() - days);

        setStartDate(startDate);
        setEndDate(today);
    };

    const checkDeploy = (checkBoxObj) => {
        let temp_button_value = true;
        if (Object.keys(checkBoxObj).length > 0) {
            setDeployButton(false);
            Object.keys(checkBoxObj).map((key) => {
                current_notification_channels.map((notification_channel) => {
                    if (notification_channel.is_primary === true) {
                        if (notification_channel.name === "Email") {
                            if (filteredResources[key].application_service_id !== null) {
                                temp_button_value = temp_button_value && true;
                            } else {
                                temp_button_value = false;
                            }
                        } else if (notification_channel.name === "PagerDuty") {
                            if (filteredResources[key].pagerduty_service_id !== null) {
                                temp_button_value = temp_button_value && true;
                            } else {
                                temp_button_value = false;
                            }
                        } else if (notification_channel.name === "OpsGenie") {
                            if (filteredResources[key].opsgenie_team_id !== null) {
                                temp_button_value = temp_button_value && true;
                            } else {
                                temp_button_value = false;
                            }
                        } else {
                            temp_button_value = false;
                        }
                    }
                })
            })
            setDeployButton(temp_button_value);
        }
        else {
            setDeployButton(false);
        }
    }

    const handleCheckBox = (key) => {
        setDeployButton(false);
        let checkBoxObj = {};
        Object.assign(checkBoxObj, checkBox);
        if (checkBoxObj[key] === true) {
            delete checkBoxObj[key];
        } else {
            checkBoxObj[key] = true
        }
        if (Object.keys(checkBoxObj).length > 0) {
            setMapButton(true);
        } else {
            setMapButton(false);
        }
        checkDeploy(checkBoxObj);
        setCheckBox(checkBoxObj);
        setAllCheckBox(false);
    };

    const handAllCheckBox = () => {
        setDeployButton(false);
        let checkBoxObj = {}
        if (allCheckBox === true) {
            Object.keys(filteredResources).map((key, index) => {
                delete checkBoxObj[key];
            })
            setCheckBox({});
            setAllCheckBox(false);
            setMapButton(false);
        } else {
            Object.keys(filteredResources).map((key, index) => {
                checkBoxObj[key] = true
            })
            setCheckBox(checkBoxObj);
            setAllCheckBox(true);
            setMapButton(true);
        }
        checkDeploy(checkBoxObj);
    };

    const handleDefaultDeploy = () => {
        setAzureDeployModal(true);
    }

    const handleUpdateEnv = () => {
        setChangeEnvModal(true);
    }

    const handleMapOpsgenieTeam = () => {
        setMapOpsGenieTeamModal(true);
    }

    const handleMapPagerdutyTeam = () => {
        setMapResourcePagerdutyServiceModal(true);
    }

    const handleMapApplicationService = () => {
        setMapServiceModal(true);
    }

    const filterByResourceType = (selectedList, selectedItem) => {
        setSearchResource(selectedList);
    }
    const unfilterByResourceType = (selectedList, removedItem) => {
        setSearchResource(selectedList);
    }

    const filterByEnvironment = (selectedEnv, selectedItem) => {
        setSearchEnvironment(selectedEnv);
    }
    const unfilterByEnvironment = (selectedEnv, removedItem) => {
        setSearchEnvironment(selectedEnv);
    }

    const filterByHealth = (selectedHealth, selectedItem) => {
        setSearchHealth(selectedHealth);
    }
    const unfilterByHealth = (selectedHealth, removedItem) => {
        setSearchHealth(selectedHealth);
    }

    const filterByServiceType = (selectedList, selectedItem) => {
        setSearchService(selectedList);
    }
    const unfilterByServiceType = (selectedList, removedItem) => {
        setSearchService(selectedList);
    }

    const handleRefresh = () => {
        dispatch(onGetAzureRefresh());
        startLoading_refresh();
    }

    const clearServiceFilter = () => {
        serviceRef.current.resetSelectedValues();
      }

    const handleDispatch = () => {
        let payload = {
            "page": 1,
            "limit": itemsPerPage,
        }
        let url = new URL(window.location.href);
        let params = new URLSearchParams(url.search);
        window.history.replaceState(null, '', url.pathname);
        setSearchHealth([]);
        setSearch('')
        setRegion("")
        setSearchResource([]);
        setSearchService([]);
        setSearchEnvironment([]);
        setSearchHealth([]);
        dispatch(onGetAzureAllResourceAlertsPage(payload))
    }


    function getNotificationServiceMapping(cloud_resource) {
        for (let notification_channel of current_notification_channels) {
            if (notification_channel.name === "OpsGenie" && notification_channel.is_primary === true) {
                if (cloud_resource.opsgenie_team_id !== null) {
                    return <div className="mb-2">
                        {allOpsGenieTeams[cloud_resource.opsgenie_team_id]}
                    </div>
                } else {
                    return <div className="mb-2"> - </div>
                }
            } else if (notification_channel.name === "Email" && notification_channel.is_primary === true) {
                if (cloud_resource.application_service_id !== null) {
                    return <Link
                        to={"/temperstack-notifications/" + cloud_resource?.application_service_id}
                        className="link-primary"
                    ><div className="mb-2">
                            {allServices[cloud_resource.application_service_id]}
                        </div></Link>
                } else {
                    return <div className="mb-2"> - </div>
                }
            } else if (notification_channel.name === "PagerDuty" && notification_channel.is_primary === true) {
                if (cloud_resource.pagerduty_service_id !== null) {
                    return <div className="mb-2">
                        {allPagerdutyServices[cloud_resource.pagerduty_service_id]}
                    </div>
                } else {
                    return <div className="mb-2"> - </div>
                }
            }
        }
        return <div className="mb-2"> - </div>
    }

    function getNotificationServiceMappingHeader() {
        for (let notification_channel of current_notification_channels) {
            if (notification_channel.name === "OpsGenie" && notification_channel.is_primary === true) {
                return <div className="mb-2">OpsGenie Team</div>
            } else if (notification_channel.name === "Email" && notification_channel.is_primary === true) {
                return <div className="mb-2">Application Service</div>
            } else if (notification_channel.name === "PagerDuty" && notification_channel.is_primary === true) {
                return <div className="mb-2">PagerDuty Service</div>
            }
        }
        return <div className="mb-2">Application Service</div>
    }

    function getNotificationServiceMappingButton() {
        for (let notification_channel of current_notification_channels) {
            if (notification_channel.name === "OpsGenie" && notification_channel.is_primary === true) {
                return (<Fragment>
                    {
                        mapButton ?
                            <DropdownItem href="#" onClick={() => handleMapOpsgenieTeam()}>Map To OpsGenie Team</DropdownItem>
                            :
                            <DropdownItem href="#" disabled>Map To OpsGenie Team</DropdownItem>
                    }
                </Fragment>)
            } else if (notification_channel.name === "Email" && notification_channel.is_primary === true) {
                return (<Fragment>
                    {
                        mapButton ?
                            <DropdownItem href="#" onClick={() => handleMapApplicationService()}>Map To Service</DropdownItem>
                            :
                            <DropdownItem href="#" disabled>Map To Service</DropdownItem>
                    }
                </Fragment>)
            } else if (notification_channel.name === "PagerDuty" && notification_channel.is_primary === true) {
                return (<Fragment>
                    {
                        mapButton ?
                            <DropdownItem href="#" onClick={() => handleMapPagerdutyTeam()}>Map To Pagerduty Service</DropdownItem>
                            :
                            <DropdownItem href="#" disabled>Map To Pagerduty Service</DropdownItem>
                    }
                </Fragment>)
            }
        }
        return (
            <Fragment>
                <DropdownItem href="/onboarding">Connect Notification</DropdownItem>
            </Fragment>)
    }

    useEffect(() => {
        dispatch(getAzureRefreshScanStatus());
    }, [getAzureRefreshScanStatus]);

    function getFilter() {
        for (let notification_channel of current_notification_channels) {
            if (notification_channel.name === "OpsGenie" && notification_channel.is_primary === true) {
                return (<Multiselect name="service_option"
                    placeholder="Opsgenie Team"
                    ref={serviceRef}
                    options={opsGenieTeamOptions}
                    displayValue="label"
                    closeOnSelect={true}
                    onSelect={filterByServiceType}
                    onRemove={unfilterByServiceType}
                    style={{optionContainer:{backgroundColor: "#382b42"}}}
                    />)
            } else if (notification_channel.name === "Email" && notification_channel.is_primary === true) {
                return (<Multiselect name="service_option"
                    placeholder="Application Service"
                    ref={serviceRef}
                    options={serviceOptions}
                    displayValue="label"
                    closeOnSelect={true}
                    onSelect={filterByServiceType}
                    onRemove={unfilterByServiceType}
                    selectedValues={initialServiceFilter}
                    style={{optionContainer:{backgroundColor: "#382b42"}}}
                    />)
            } else if (notification_channel.name === "PagerDuty" && notification_channel.is_primary === true) {
                return (<Multiselect name="service_option"
                    placeholder="Pagerduty Service"
                    ref={serviceRef}
                    options={pagerdutyServiceOptions}
                    displayValue="label"
                    closeOnSelect={true}
                    onSelect={filterByServiceType}
                    onRemove={unfilterByServiceType} 
                    style={{optionContainer:{backgroundColor: "#382b42"}}}
                    />)
            }
        }
        return (<Fragment />)
    }

    const [isOpen, setIsOpen] = useState(false);
    const [isDateOpen, setIsDateOpen] = useState(false);
    const toggle = () => setIsOpen(!isOpen);
    const toggleDates = () => setIsDateOpen(!isDateOpen);
    const [isLoading, setIsLoading] = useState(false);

    const headers = [
        { label: "Resource Name", width: 2, marginBottom: 2, textCenter: true },
        { label: "Type", width: 1, marginBottom: 2, textCenter: true },
        { label: "Environment", width: 2, marginBottom: 2, textCenter: true },
        { label: "Location", width: 1, marginBottom: 2, textCenter: true },
        { label: "Alert Health", width: 1, marginBottom: 2, textCenter: true },
        { label: getNotificationServiceMappingHeader(), width: 2, marginBottom: 2, textCenter: true },
        { label: "Actions", width: 2, marginBottom: 2, textCenter: true },
    ];

    const customStyles = {
        zIndex: 9999,
        control: (provided, state) => ({
          ...provided,
          background: '#382b42', // Background color of the control (react-select)
          borderRadius: 0,
          color: "white",
          zIndex: 100,
          position:"relative",
          borderColor: state.isFocused ? 'rgb(white, 1)' : 'rgb(white, 0.7)', // Border color when focused
        }),
        option: (provided, state) => ({
          ...provided,
          position:"relative",
          zIndex: 100,
          backgroundColor: state.isSelected ? '#292036' : state.isFocused ? '#2d2941' : '#382b42',
          color: state.isSelected ? '#ffffff' : '#ffffff', // Text color of dropdown options
        }),
        menu: (provided) => ({
          ...provided,
          background: '#382b42', // Background color of the dropdown menu
          position: "absolute",
          zIndex: 200,
        }),
        singleValue: (provided) => ({
          ...provided,
          position:"relative",
          color: '#ffffff', // Color of the selected value
          zIndex: 100, 
        }),
      };

    return (
        <React.Fragment>
            <div className="table-responsive react-table">
                <ResourceActions
                    selectedPage={selectedPage}
                    total_resources={total_resources}
                    itemsPerPage={itemsPerPage}
                    handlePageClick={handlePageClick}
                    initialSearch={search}
                    isOpen={isOpen}
                    toggle={toggle}
                    setSearch={setSearch}
                    setRegion={setRegion}
                    initialRegion={region}
                    resourceFilter={resourceFilter}
                    environmentsFilter={environmentsFilter}
                    healthFilter={healthFilter}
                    filterByResourceType={filterByResourceType}
                    unfilterByResourceType={unfilterByResourceType}
                    filterByEnvironment={filterByEnvironment}
                    unfilterByEnvironment={unfilterByEnvironment}
                    filterByHealth={filterByHealth}
                    unfilterByHealth={unfilterByHealth}
                    getFilter={getFilter}
                    getNotificationServiceMappingButton={getNotificationServiceMappingButton}
                    deployButton={deployButton}
                    handleDefaultDeploy={handleDefaultDeploy}
                    handleRefresh={handleRefresh}
                    initiateRescan={azure_rescan_status}
                    startDate={startDate}
                    endDate={endDate}
                    handleStartDateChange={handleStartDateChange}
                    handleEndDateChange={handleEndDateChange}
                    toggleDates={toggleDates}
                    isDateOpen={isDateOpen}
                    handlePredefinedDateChange={handlePredefinedDateChange}
                    handleDispatch={handleDispatch}
                    clearServiceFilter={clearServiceFilter}
                    initialResourceFilter={initialResourceFilter}
                    initialEnvironmentFilter={initialEnvironmentFilter}
                    initialHealthFilter={initialHealthFilter}
                />
            </div>
            <div className="header">
                <div className="resources-header-card">
                    <Row className="align-items-center padding-t-10">
                        {
                            <React.Fragment>
                                <Col md="1">
                                    <div className="mb-2 text-center">
                                        {
                                            allCheckBox ?
                                                <i className="bx bx-check-square bx-sm" onClick={() => handAllCheckBox()}></i>
                                                :
                                                <i className="bx bx-square bx-sm" onClick={() => handAllCheckBox()}></i>
                                        }
                                    </div>
                                </Col>
                                {headers.map((header, index) => (
                                    <Col md={header.width} key={index}>
                                        <div className={`mb-${header.marginBottom} ${header.textCenter && "text-center"}`}>
                                            {header.label}
                                        </div>
                                    </Col>
                                ))}
                            </React.Fragment>
                        }
                    </Row>
                </div>
            </div>
            <ResourceTableRow
                type='Azure'
                isLoading={isLoading}
                checkBox={checkBox}
                filteredResources={filteredResources}
                total_resources={total_resources}
                handleCheckBox={handleCheckBox}
                getNotificationServiceMapping={getNotificationServiceMapping}
                handleIndividualDeploy={handleIndividualDeploy}
                startLoading2={startLoading2}
            />
            <DefaultAlertsModal
                type="Azure"
                isOpen={azureDeployModal}
                checkBox={checkBox}
                filteredResources={filteredResources}
                handleCheckBox={handleCheckBox}
                cancelDeployModal={cancelDeployModal}
                startLoading2={startLoading2}
                handleDeploy={handleDeploy}
                linkTo="/azure-thresholds" />
            <MapOpsGenieModal
                type="Azure"
                isOpen={mapOpsGenieTeamModal}
                checkBox={checkBox}
                filteredResources={filteredResources}
                handleCheckBox={handleCheckBox}
                opsGenieTeamOptions={opsGenieTeamOptions}
                environments={environments}
                handleOGFormChange={handleOGFormChange}
                handleEnvironmentChange={handleEnvironmentChange}
                startLoading1={startLoading1}
                handleOpsGenieTeamMapping={handleOpsGenieTeamMapping}
                cancelMapOpsGenieTeamModal={cancelMapOpsGenieTeamModal}
                customStyles={customStyles}
            />
            <MapPagerDutyModal
                type="Azure"
                isOpen={mapResourcePagerdutyServiceModal}
                checkBox={checkBox}
                filteredResources={filteredResources}
                handleCheckBox={handleCheckBox}
                pagerdutyServiceOptions={pagerdutyServiceOptions}
                environments={environments}
                handlePDFormChange={handlePDFormChange}
                handleEnvironmentChange={handleEnvironmentChange}
                startLoading1={startLoading1}
                handlePagerdutyServiceMapping={handlePagerdutyServiceMapping}
                cancelMapResourcePagerdutyServiceModal={cancelMapResourcePagerdutyServiceModal}
                customStyles={customStyles}
            />
            <MapResourceServiceModal
                type="Azure"
                isOpen={mapServiceModal}
                checkBox={checkBox}
                filteredResources={filteredResources}
                handleCheckBox={handleCheckBox}
                serviceOptions={serviceOptions}
                environments={environments}
                handleServiceFormChange={handleServiceFormChange}
                handleEnvironmentChange={handleEnvironmentChange}
                startLoading1={startLoading1}
                handleServiceMapping={handleServiceMapping}
                cancelMapServiceModal={cancelMapServiceModal}
            />
            <Loader
                isOpen={azureRefreshModal}
                lottieJson={refreshResourcesLottie}
                messageHeader="Scanning Azure"
                message="Please wait while we scan your Azure universe for new resources."
            />
            <Loader
                isOpen={isLoading1}
                lottieJson={connectTeamLottie}
                messageHeader="Resource - Team Mapping"
                message="Please wait while we map the selected resources to the respective team."
            />
            <Loader
                isOpen={isLoading2}
                lottieJson={delpoyAlertsLottie}
                messageHeader="Deploying Alerts"
                message="That was easy! Hang tight while we deploy your alerts."
            />
        </React.Fragment>
    );
}

AzureResourceTab.propTypes = {
    orders: PropTypes.array,
    resourceId: PropTypes.number,
    services: PropTypes.any,
    opsgenie_teams: PropTypes.any,
    mapServiceToResource: PropTypes.func,
    tabId: PropTypes.string,
    onGetServices: PropTypes.func,
}

export default withRouter(AzureResourceTab);
